export const TRANSACTION_TYPE = "transactionType";
export const TENANT_LEGAL_NAME = "tenantLegalName";
export const LANDLORD_LEGAL_NAME = "landlordLegalName";
export const LANDLORD_BROKER = "landlordBroker";
export const TENANT_BROKER = "tenantBroker";
export const BUILDING_ADDRESS = "buildingAddress";
export const RENTABLE_SQUARE_FOOTAGE = "squareFootage";
export const SUITE_NUMBERS = "suiteNumber";
export const EFFECTIVE_DATE = "effectiveDate";
export const COMMENCEMENT_DATE = "commencementDate";
export const TERM = "term";
export const EXPIRATION_DATE = "expirationDate";
export const TENANT_IMPROVEMENT = "tenantImprovement";
export const RENT_ABATEMENT = "rentAbatement";
export const BASE_RENT_SCHEDULE = "baseRentSchedule";
export const SECURITY_DEPOSITY_AMOUNT = "securityDeposit";
export const LETTER_OF_CREDIT_AMOUNT = "letterOfCredit";
export const RENEWAL_OPTION = "renewalOption";
export const EARLY_TERMINATION = "earlyTermination";
export const RIGHT_TO_SUBLET = "rightToSublet";
export const RENT_COMMENCEMENT_DATE = "rentCommencementDate";
export const TAX_ABATEMENT = "taxAbatement";
export const PERCENT_RENT = "percentageRent";
export const LATE_FEE = "lateFee";
export const PRO_RATA_SHARE = "proRataShare";
export const OPEX_PRO_RATA_SHARE = "opexProRataShare";
export const TAX_PRO_RATA_SHARE = "taxProRataShare";
export const RIGHT_OF_FIRST_OFFER = "rightOfFirstOffer";
export const RIGHT_OF_FIRST_REFUSAL = "rightOfFirstRefusal";
export const PARKING = "parking";
export const LANDLORD_RELOCATION = "landlordRelocation";
export const EXPANSION = "expansion";
export const EXCLUSIVE_USE = "exclusiveUse";
export const PURCHASE_RIGHT = "purchaseRight";
export const ESTOPPEL = "estoppel";
export const LANDLORD_TERMINATION = "landlordTermination";
export const CONTRACTION = "contractionRight";
export const PROHIBITED_USE = "prohibitedUse";
export const PERMITTED_USE = "permittedUse";
export const GUARANTOR = "guarantor";
export const SIGNAGE = "signage";
export const TELECOM = "telecom";

export const NONE_FOUND = "None Found";

/* SUB TERMS */
export const SUB_TERM_SUMMARY = "summary";
export const RENTAL_RATE = "rentalRate";
export const ACCEPTANCE_PERIOD = "acceptancePeriod";
export const RENEWAL_PERIOD = "renewalPeriod";
export const ADVANCED_NOTICE_PERIOD = "advancedNoticePeriod";
export const NUMBER_OF_ADDITIONAL_PERIODS = "numberOfAdditionalPeriods";
export const EXPANSION_SPACE = "expansionSpace";
export const REFUSAL_SPACE = "refusalSpace";
export const OFFERED_SPACE = "offeredSpace";
export const CONTRACTION_SPACE = "contractionSpace";
export const CONTRACTION_FEE = "contractionFee";
export const ONETIME_ONGOING = "oneTimeOrOngoing";
export const RENEWAL_PERIOD_TERM = "renewalPeriodTerm";
export const TI_SUNSET = "tiSunset";
export const TI_REMAINING = "tiRemaining";
export const TI_AMOUNT = "tiAmount";
export const EXPIRATION_DATE_OF_RIGHT = "expirationDateOfRight";
export const TERMINATION_FEE = "terminationFee";
export const OPTION_END_DATE = "optionEndDate";
export const EFFECTIVE_DATE_OF_RIGHT = "effectiveDateOfRight";
export const EARLY_MOVE_OUT_DATE = "earlyMoveOutDate";
export const RIGHT_IS_DECLINED = "rightIsDeclined";
